export default __webpack_public_path__ + "static/to-down--black-en-82432c94aeddd35010a40209b1d01611.svg";